import { Replay, init, configureScope } from '@sentry/browser'
import getEnv, { ENV_VARIABLES } from 'src/config'
import { isLocalhost } from './url'
const packageJson = require('../../package.json')

const getReplayInstance = () => {
  if (window.replayInstance) {
    return window.replayInstance
  } else {
    window.replayInstance = new Replay({
      networkDetailAllowUrls: ['https://dev-core-app.dental21.de/api/v1/public/appointment-bundles'],
      networkCaptureBodies: true,
    })
    return window.replayInstance
  }
}

export const initializeSentry = (clinicId?: string, successUrl?: string) => {
  const sentryDns = getEnv(ENV_VARIABLES.SENTRY_DSN)
  const environment = getEnv(ENV_VARIABLES.ENV)
  const replayInstance = getReplayInstance()

  if (sentryDns && !isLocalhost) {
    init({
      dsn: sentryDns,
      environment: environment,
      release: `availy-${packageJson.version}`,
      ignoreErrors: [
        'Cancel rendering route',
        'replaceState',
        'Importing a module script failed',
        'browser-ui',
        'Usercentrics',
        'module code',
        'portalId',
        "Cannot read properties of undefined (reading 'lat')",
        "Cannot read properties of undefined (reading 'lat')",
        'Failed to fetch',
        'Could not load "controls"',
        `evaluating 'a.L'`,
        'The operation is insecure',
        'Eg.close',
      ],

      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      integrations: [replayInstance],
    })

    if (clinicId || successUrl) {
      configureScope((scope) => {
        scope.setTag('clinic-id', clinicId)
        scope.setTag('success-url', successUrl || '')
      })
    }
  }
}
